import React from 'react';

type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'muted' | 'primary';

interface StatusBadgeProps {
  label: string;
  variant: BadgeVariant;
  dot?: boolean;
  className?: string;
}

const variantStyles: Record<BadgeVariant, { bg: string; color: string; dot: string }> = {
  success: {
    bg: 'rgba(16, 185, 129, 0.15)',
    color: 'var(--success)',
    dot: 'var(--success)',
  },
  danger: {
    bg: 'rgba(239, 68, 68, 0.15)',
    color: 'var(--danger)',
    dot: 'var(--danger)',
  },
  warning: {
    bg: 'rgba(245, 158, 11, 0.15)',
    color: 'var(--warning)',
    dot: 'var(--warning)',
  },
  info: {
    bg: 'rgba(59, 130, 246, 0.15)',
    color: 'var(--info)',
    dot: 'var(--info)',
  },
  muted: {
    bg: 'rgba(100, 116, 139, 0.15)',
    color: 'var(--muted-foreground)',
    dot: 'var(--muted-foreground)',
  },
  primary: {
    bg: 'rgba(14, 165, 233, 0.15)',
    color: 'var(--primary)',
    dot: 'var(--primary)',
  },
};

export default function StatusBadge({ label, variant, dot = false, className = '' }: StatusBadgeProps) {
  const styles = variantStyles[variant];
  return (
    <span
      className={`status-badge ${className}`}
      style={{ backgroundColor: styles.bg, color: styles.color }}
    >
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full flex-shrink-0"
          style={{ backgroundColor: styles.dot }}
        />
      )}
      {label}
    </span>
  );
}